import React from "react";
import { Envelope } from "../icons";
import { useTranslation } from "react-i18next";
import { useUsesDesign } from "../context/GuestCheckoutSettingsContext";

const WhatsNextCard: React.FC = () => {
  const { t } = useTranslation();
  const usesDesign = useUsesDesign();

  return (
    <div className="gcw:rounded-lg gcw:border gcw:border-gray-200 gcw:bg-white gcw:shadow-sm whats-next-card gcw:mb-4">
      <div className="gcw:p-bs-3">
        <div className="gcw:flex gcw:items-center gcw:mb-2">
          {/* The design states its panels without an ornament beside the
              heading, as the success card does. */}
          {!usesDesign && <Envelope size={20} className="gcw:text-warning gcw:me-2" aria-hidden="true" />}
          <h2 className="gcw:text-subtitle gcw:mb-0">{t("whats_next_title", "What's Next?")}</h2>
        </div>

        {/* A real list, so a screen reader announces how many steps there are
            and which one it is on. The bullet stays a decorative glyph rather
            than a list marker: Tailwind's preflight strips `list-style`, and
            the glyph carries the warning colour the card's own rules give it
            (confirmation.scss, _design-dark.scss). */}
        <ul>
          <li className="next-step gcw:flex gcw:items-start">
            <span className="step-icon gcw:me-2" aria-hidden="true">
              •
            </span>
            <p className="gcw:text-ref">
              <strong>{t("whats_next_email_title", "Confirmation Email:")}</strong>{" "}
              {t(
                "whats_next_email_message",
                "You'll receive a detailed confirmation email within the next few minutes with your booking reference and receipt.",
              )}
            </p>
          </li>

          <li className="next-step gcw:flex gcw:items-start">
            <span className="step-icon gcw:me-2" aria-hidden="true">
              •
            </span>
            <p className="gcw:text-ref">
              <strong>{t("whats_next_arrival_title", "Arrival Instructions:")}</strong>{" "}
              {t(
                "whats_next_arrival_message",
                "Please arrive 10 minutes before your reservation time. Present your booking confirmation to the host.",
              )}
            </p>
          </li>

          <li className="next-step gcw:flex gcw:items-start">
            <span className="step-icon gcw:me-2" aria-hidden="true">
              •
            </span>
            <p className="gcw:text-ref">
              <strong>{t("whats_next_changes_title", "Need Changes?")}</strong>{" "}
              {t(
                "whats_next_changes_message",
                "Contact us at least 24 hours before your booking to make any modifications.",
              )}
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default WhatsNextCard;
